import React from 'react';
import { Typography, Container } from '@mui/material';

const TestPage = () => {
  return (
    <Container>
      <Typography variant="h4" component="h1">
        Test Page - This should render
      </Typography>
      <Typography variant="body1">
        If you can see this, the routing is working.
      </Typography>
    </Container>
  );
};

export default TestPage;

